import gql from "graphql-tag";

import UserFragment from "../../../fragments/user.fragment";

const Login = gql`
  mutation($input: LoginInput) {
    login(input: $input) {
      ...UserFragment
    }
  }
  ${UserFragment}
`;

export default Login;
